import { Line } from 'vue-chartjs';
import moment from 'moment-timezone';
// const { reactiveProp } = mixins
const months = moment()._locale._monthsShort;
export default {
	extends: Line,
	/* mixins: [reactiveProp], */
	data() {
		return {
			gradient: null,
			trendData: {
				labels: months
					.map(
						e =>
							e +
							' ' +
							moment()
								.subtract(1, 'year')
								.format('YY')
					)
					.concat(months.map(e => e + ' ' + moment().format('YY'))),
				datasets: [
					{
						label: 'PDF',
						borderColor: '',
						pointBackgroundColor: 'black',
						borderWidth: 1,
						pointBorderColor: 'white',
						backgroundColor: '',
						data: [],
					},
					{
						label: 'XLSX',
						borderColor: '',
						pointBackgroundColor: 'black',
						borderWidth: 1,
						pointBorderColor: 'white',
						backgroundColor: '',
						data: [],
					},
					{
						label: 'TXT',
						borderColor: '',
						pointBackgroundColor: 'black',
						borderWidth: 1,
						pointBorderColor: 'white',
						backgroundColor: '',
						data: [],
					},
					{
						label: 'CSV',
						borderColor: '',
						pointBackgroundColor: 'black',
						borderWidth: 1,
						pointBorderColor: 'white',
						backgroundColor: '',
						data: [],
					},
					{
						label: 'HTML',
						borderColor: '',
						pointBackgroundColor: 'black',
						borderWidth: 1,
						pointBorderColor: 'white',
						backgroundColor: '',
						data: [],
					},
				],
			},
		};
	},
	methods: {
		getRandomInt(max) {
			return Math.floor(Math.random() * Math.floor(max));
		},
	},
	props: ['lineChartData', 'options'],
	mounted() {
		this.gradient = [
			this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
			this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
			this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
			this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
			this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450),
		];
		let temp = JSON.parse(JSON.stringify(this.trendData));
		for (let i = 0; i < 5; i++) {
			this.gradient[i].addColorStop(
				0,
				`rgba(${this.getRandomInt(255)}, ${this.getRandomInt(
					255
				)},${this.getRandomInt(255)}, ${Math.random()})`
			);
			this.gradient[i].addColorStop(
				0.5,
				`rgba(${this.getRandomInt(255)}, ${this.getRandomInt(
					255
				)},${this.getRandomInt(255)}, ${Math.random()})`
			);
			this.gradient[i].addColorStop(
				1,
				`rgba(${this.getRandomInt(255)}, ${this.getRandomInt(
					255
				)},${this.getRandomInt(255)}, ${Math.random()})`
			);
			temp.datasets[i].backgroundColor = this.gradient[i];
		}
		// console.log(this.lineChartData)
		for (let extn in this.lineChartData) {
			for (let index in temp.datasets) {
				if (temp.datasets[index].label == extn) {
					temp.datasets[index].data = this.lineChartData[extn];
					temp.datasets[index].borderColor = `rgba(${this.getRandomInt(
						255
					)}, ${this.getRandomInt(255)},${this.getRandomInt(255)}, 1})`;
				}
			}
		}

		this.renderChart(temp, this.options);
	},
};
